export default __webpack_public_path__ + "static/media/gindrinks.e1e015e5.jpg";